import {SODeleteViewGrant} from '../../core/view-grant/so-delete-view-grant';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteViewGrant extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteViewGrant;
}